import { Routes } from '@angular/router';
import { MsalGuard } from '@groundworks/ngx-groundworks-auth';
import { ShellComponent } from './shell.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    component: ShellComponent,
    loadChildren: () => import('./features/routing/home-page.routing')
      .then(m => m.HOME_PAGE_ROUTES)
  }
];
